import FileLoadingScreen from './component/FileLoadingScreen.vue';
import FileLoadingManager from './model/FileLoadingManager';
import fileLoadingModule from './module/fileLoadingModule';

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }

    const fileLoadingManager = new FileLoadingManager(options.store);
    options.store.registerModule('fileLoading', fileLoadingModule);

    // After creating fileLoading manager and registering store for fileLoading
    // we need to update store.
    fileLoadingManager.update();

    Vue.component('file-loading-component', FileLoadingScreen);

    Vue.mixin({
      // Add component lifecycle hooks or properties.
      computed: {
        isLoading() {
          return options.store.state.fileLoading.isLoading;
        },
      },
    });

    /* eslint no-param-reassign: 0 */
    Vue.prototype.$fileLoadingManager = fileLoadingManager;
    /* eslint no-param-reassign: 1 */
  },
};
